/**
 * 校验相关
 * Created by Wang Bingyang.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 *
 * @param value
 * @returns {boolean}
 */
export function isEmpty(value) {
  const { hasOwnProperty } = Object.prototype;
  if (value == null) {
    return true;
  }
  for (const key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}
